import { makeAutoObservable } from 'mobx';
import { LoginManager } from '../../../../core-logic/modules/authorization/managers/LoginManager';

class LoginUIManager {
  constructor(private loginManager: LoginManager) {
    makeAutoObservable(this, {});
  }

  get coreManager() {
    return this.loginManager;
  }
}

export { LoginUIManager };
